export default __webpack_public_path__ + "static/media/bittrex-logo-black.fb79915a.svg";